import axios from 'axios'

import { EInvoicingScheme } from '../Global/EInvoicingData'
import { ValidationFieldsInterface } from '../Interfaces/ValidationFieldsInterface'
import { getRequestConfig } from './index'

export async function getValidationFields(
  address: string,
  scheme: EInvoicingScheme,
): Promise<ValidationFieldsInterface> {
  if (address && scheme) {
    const numbericAddress = address ? address.replace(/[-:]/g, '') : ''
    try {
      const res = await axios.get(`/e-invoice-onboarding/validation/${scheme}/${numbericAddress}`, getRequestConfig())
      return res.data as ValidationFieldsInterface
    } catch (e) {
      console.error(e, 'failed to fetch required fields')
    }
  }
  return { required: [] }
}
